import { defineComponent as _defineComponent } from 'vue'

import AudioControl from '../AudioControl.vue';
import VideoControl from '../VideoControl.vue';
import ManageMemberControl from '../ManageMemberControl.vue';
import ChatControl from '../ChatControl.vue';
import MasterApplyControl from '../ManageStageControl.vue';
import MemberApplyControl from '../ApplyControl/MemberApplyControl.vue';
import MoreControl from '../MoreControl/index';
import bus from '../../../hooks/useMitt';
import '../../../directives/vTap';

import useRoomFooter from './useRoomFooterHooks';


export default /*#__PURE__*/_defineComponent({
  __name: 'indexH5',
  emits: ['show-overlay'],
  setup(__props, { emit }) {

const { roomStore, isMaster, isAdmin, isAudience } = useRoomFooter();



function handleControlClick(name: string) {
  bus.emit('experience-communication', name);
}

function handleShowOverlay(data: { name: string; visible: boolean }) {
  emit('show-overlay', data);
}

return { __sfc: true,roomStore, isMaster, isAdmin, isAudience, emit, handleControlClick, handleShowOverlay, AudioControl, ChatControl }
}

})